import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import ChildrenServiceOrderLoader from './_load/ChildrenServiceOrderLoader'
import ServiceOrdersLoader from './_load/ServiceOrderLoader'

const TemplateLMDaSilvaPdfPage = ({ id }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={parseInt(id)}>
        <ChildrenServiceOrderLoader parentId={parseInt(id)}>
          <PageHeader />
          <PageContent />
        </ChildrenServiceOrderLoader>
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateLMDaSilvaPdfPage
